import dayjs from 'dayjs'
import {getItem, removeItem, setItem} from '@/helpers/persistantStorage'

const SESSION_DATE_KEY = 'nt_session_date'

export const setFormatDate = (date) => dayjs(date).format('YYYY-MM-DD')

export const getDateOneWeekAgo = (date) => dayjs(date).subtract(6, 'day').toDate()

export const getInitialDateRange = () => {
  const cachedRange = getItem(SESSION_DATE_KEY)
  if (cachedRange) return cachedRange

  const now = new Date()
  const range = [setFormatDate(getDateOneWeekAgo(now)), setFormatDate(now)]

  saveSessionDateRange(range)
  return range
}

export const saveSessionDateRange = (dates) => setItem(SESSION_DATE_KEY, dates)

export const clearSessionDateRange = () => removeItem(SESSION_DATE_KEY)

export const isDefaultWeekRange = (range) => {
  if (!range || range.length !== 2) return false

  const [start, end] = range
  const now = dayjs()
  const expectedStart = now.subtract(7, 'day').format('YYYY-MM-DD')
  const expectedEnd = now.format('YYYY-MM-DD')

  return start === expectedStart && end === expectedEnd
}
